import React, { useContext } from 'react';
import PatientOtherUserPanel from './patient_other_user_panel';
import Context from '../../../../utils/context';

export default function ConversationOtherUserProfile({ otherUser }) {
  const context = useContext(Context);
  const isMobile = context.viewport.getIsMobile();

  return (
    <div className='right-side-wrap container h-100'>
      <div className='row h-100'>
        <div className='col'>
          <PatientOtherUserPanel otherUser={otherUser} isMobile={isMobile} />
        </div>
      </div>
    </div>
  );
}
